import { render, staticRenderFns } from "./MediaViewPage.vue?vue&type=template&id=131dce1d&scoped=true"
import script from "./MediaViewPage.vue?vue&type=script&lang=js"
export * from "./MediaViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131dce1d",
  null
  
)

export default component.exports